/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AmountSummaryVo,
  CouponInfoVo,
  SummaryItemVo,
  UserAddressVo,
  ZeroInfoVo,
  AmountDetailVo,
  AgeLimitInfoVo,
} from '@/apis/checkout/checkout.interface';
import { CHECKOUT_PAYMENT_TRACK_MAP } from '@/apis/checkout/constants/constants';
import { getUserUUIDFromCookie } from '@/utils/userUtils';
import { Instance, types } from 'mobx-state-tree';
import { CreditCardStoreModel } from './CreditCardStore';
import { AddressStoreModel } from './checkout/addressStore';
import { CouponStoreModel } from './checkout/couponStore';
import { MemberStoreModel } from './checkout/memberStore';
import { PaymentStoreModel } from './checkout/paymentStore';
import { PointStoreModel } from './checkout/pointStore';
import { PriceStoreModel } from './checkout/priceStore';
import { StaticStoreModel } from './checkout/staticStore';
import { VenderStoreModel } from './checkout/venderStore';
import { withSetPropAction } from './helpers/withSetPropAction';

// 信用卡结构
const ICreditCardVo = types.model('CreditCardVo', {
  cardNo: types.string,
  expireDateMonth: types.string,
  expireDateYear: types.string,
  cvv: types.string,
});
const IBnpCreditCardVo = types.model('BnpCreditCardVo', {
  brand: types.string,
  number: types.string,
  expiryDate: types.string,
  securityCode: types.string,
  MerchantID: types.string,
  Data: types.string,
  Len: types.number,
  actionUrl: types.string,
});

// Commons
const fontSize_14 = '14px';
const fontSize_18 = '18px';
const textBold_700 = 'textBold';
const lineHeight_18 = '18px';
const JOYBUY_BLACK = '#1A1A1A';
const JOYBUY_RED = '#CC0C1C';
const JOYBUY_GRAY = '#888B94';
const JOYBUY_GREEN = '#269636';
// Bundle
const JOYBUY_TEXT_1 = {
  fontSize: fontSize_14,
  height: lineHeight_18,
  lineHeight: lineHeight_18,
  color: JOYBUY_BLACK, // 25.01.09： 兜底颜色, 由于JDIPrice组件逻辑
};

export const CheckoutStoreModel = types
  .model('CheckoutStore')
  .props({
    loading: types.maybe(types.boolean),
    error: types.maybe(types.string),
    orderList: types.array(types.frozen({})),
    currency: types.optional(types.string, ''),
    currencySymbol: types.optional(types.string, ''),
    languageCode: types.optional(types.string, ''),
    // Buy now return id
    buySkuId: types.optional(types.string, ''),
    // checkout router params
    queryParams: types.optional(types.frozen({}), {}),
    queryCurrentOrder: types.optional(types.frozen({}), {
      orderStr: {
        id: '',
        useBestCoupon: true,
        visitorUuid: getUserUUIDFromCookie(),
        paymentExtParam: JSON.stringify({
          disabledPayMethods: '',
          currentUserPayMethods: '',
        }),
      },
      mergeCart: true,
      immediatelyBuy: false,
      verticalTag: 'cn_ybxt_b2c',
      lang: 'zh_CN',
      isPresale: false,
      ptFlag: false,
      client: 'pc',
    }),
    paymentDetail: types.array(types.frozen({})),
    ageLimitInfo: types.frozen<AgeLimitInfoVo | null>(null),
    ageLimitDrawer: types.optional(types.boolean, false),
    adultUserCheck: types.optional(types.string, ''),
    orderPaymentPrice: types.optional(types.string, ''),
    imageDomain: types.maybe(types.string),
    // submit order default error tips
    commonError: types.optional(types.frozen({}), {
      err: '',
    }),
    orderErrorOpen: types.optional(types.boolean, false),
    orderErrorMsg: types.optional(types.frozen({}), {
      err: '',
      title: '',
      onClose: () => {
        console.log('');
      },
      btnText: 'Back to cart',
      outStockList: [],
      cancelBtnText: '',
      isBackdrop: false,
      closeBtnStyle: {},
      onCancel: () => {
        console.log('');
      },
    }),
    addressId: types.maybe(types.number),
    repayOrderId: types.maybe(types.string),
    safetyLoading: types.optional(types.boolean, false),
    cardModalOpen: types.optional(types.boolean, false),
    billingAddress: types.optional(types.frozen({}), {}),
    isBillingAddressEdit: types.optional(types.boolean, false),
    creditCardStore: types.optional(CreditCardStoreModel, {}),
    zeroInfo: types.optional(types.frozen({}), {}),
    browserInfo: types.optional(types.frozen({}), {
      acceptHeaders: 'application/json, text/plain, */*',
      // ipAddress: "2001:0db8:85a3:0000:0000:8a2e:0370:7ç334",
      javaEnabled: false,
      javaScriptEnabled: true,
      // BNP后续下线，暂时保留
      language: 'en-GB',
      colorDepth: 24,
      screenHeight: 723,
      screenWidth: 1536,
      timeZoneOffset: '',
      userAgent: '',
    }),
    /** 是否全部为月黑风高品 */
    isAllHappyHour: types.optional(types.boolean, false),
    /** 结算页商品埋点数据 */
    trackOrderList: types.array(types.frozen({})),
    /** 价格埋点数据 */
    paymentTrackInfo: types.optional(types.frozen({}), {}),
    skuIds: types.array(types.frozen(String)),
    // 结算页商品弹窗idnex
    currentDetailIndex: types.optional(types.number, 0),
    currentDetailList: types.array(types.frozen({})),
    // 优惠券信息-埋点
    trackCouponInfo: types.optional(types.frozen({}), {}),
    // 当前编辑的包裹id
    currentEditBundleUuid: types.optional(types.string, ''),
    isPromiseListShow: types.optional(types.boolean, true),
    isClient: types.optional(types.boolean, false),
    pickUser: types.frozen({}), // 自提联系人
    addressStore: types.optional(AddressStoreModel, {}),
    venderStore: types.optional(VenderStoreModel, {}),
    couponStore: types.optional(CouponStoreModel, {}),
    paymentStore: types.optional(PaymentStoreModel, {}),
    priceStore: types.optional(PriceStoreModel, {}),
    staticStore: types.optional(StaticStoreModel, {}),
    memberStore: types.optional(MemberStoreModel, {}),
    pointStoreModel: types.optional(PointStoreModel, {}),
  })
  .views((self) => ({}))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setLocalInfo: (data: any = {}) => {
      self.currency = data.currencyCode || data.currency;
      self.currencySymbol = data.currencySymbol;
      self.languageCode = data.languageCode;
    },
    setQueryParams: (data: any) => {
      self.queryParams = data;
      self.buySkuId = data.id;
    },
    setAgeLimitInfo: (data: AgeLimitInfoVo) => {
      self.ageLimitInfo = data;
      if (data.containAdultProducts) {
        self.setAgeLimitDrawer(true);
      }
    },
    setAgeLimitDrawer: (data: boolean) => {
      self.ageLimitDrawer = data;
    },
    setAdultUserCheck: (data: string) => {
      self.adultUserCheck = data;
    },
    setPaymentDetail: (amountSummary: AmountSummaryVo) => {
      const paymentDetail: any[] = [];
      // 订单应付金额
      self.orderPaymentPrice = amountSummary.totalAmount?.amount || '';
      const trackObj: any = {};
      // Changing of data
      [
        'productAmount',
        'discount',
        'promotions',
        'coupons',
        'subtotal',
        'discounts',
        'freightAmount',
        'totalService',
        'totalAmount',
      ].map((key: string) => {
        console.log(amountSummary);
        const obj = (amountSummary as AmountSummaryVo)[key];
        const savedPrice = (amountSummary as AmountSummaryVo)['promotionsTotal']?.amount || null;

        trackObj.save = savedPrice;
        const trackKey = (CHECKOUT_PAYMENT_TRACK_MAP as any)[
          key as keyof typeof CHECKOUT_PAYMENT_TRACK_MAP as string
        ];

        if (trackKey) {
          trackObj[trackKey] = obj?.amount || '-100';
        }

        if (!obj) {
          return;
        }

        const objRes: any = {
          ...obj,
        };
        switch (key) {
          case 'discount':
          case 'promotions':
          case 'coupons':
            objRes.zf = true;
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
              color: JOYBUY_RED,
            };
            paymentDetail.push(objRes);
            break;
          case 'subtotal':
            objRes.labelSpacing = 'orderTotalMain';
            // objRes.subLabel = '';
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
            };
            objRes.amountDetail = objRes?.amountDetail?.map((item: AmountDetailVo) => {
              return {
                ...item,
                divider: item.key === 'Subtotal',
                labelClassName: item.key === 'Subtotal' && textBold_700,
              };
            });
            paymentDetail.push(objRes);
            break;
          case 'productAmount':
            objRes.labelClassName = textBold_700;
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
            };
            paymentDetail.push(objRes);
            break;
          case 'totalAmount':
            objRes.labelClassName = textBold_700;
            objRes.containerSpacing = 'orderTotalContainer';
            objRes.labelSpacing = 'orderTotalMain';
            objRes.saved = {
              label: 'Saved',
              subLabelSpacing: 'orderTotalSubLabel',
              amount: savedPrice,
              savePriceShowStyles: {
                ...JOYBUY_TEXT_1,
                color: JOYBUY_RED,
              },
            };
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
              fontSize: fontSize_18,
              marginLeft: '8px',
            };
            paymentDetail.push(objRes);
            break;
          case 'freightAmount':
            // case "totalService":
            // ------ label --------- //
            // objRes.divider = !amountSummary['totalService'];
            // ------ price --------- //
            objRes.showSubPricing = !!(
              obj &&
              parseFloat(obj.originalAmount) > 0 &&
              parseFloat(obj.originalAmount) > parseFloat(obj.amount)
            );
            objRes.amount = obj && parseFloat(obj.amount) === 0 ? 'FREE' : obj.amount;
            // ------ styles --------- //
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
              color: JOYBUY_GREEN,
            };
            objRes.subPriceStyle = {
              marginRight: objRes.showSubPricing ? '8px' : '0px',
              ...JOYBUY_TEXT_1,
              color: objRes.showSubPricing && JOYBUY_GRAY, // 25.01.09: 必须放在JOYBUY_TEXT 下行
              display: objRes.showSubPricing === false && 'none',
            };
            paymentDetail.push(objRes);
            break;

          case 'totalService':
            objRes.divider = true;
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
              marginLeft: '8px',
            };
            paymentDetail.push(objRes);
            break;
          case 'discounts':
            objRes.zf = true;
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
              color: JOYBUY_RED,
            };
            objRes.amountDetail = objRes.amountDetail?.map((item: AmountDetailVo) => {
              return {
                ...item,
                divider: item.key === 'totalDiscounts',
                color: item.key === 'totalDiscounts' && JOYBUY_RED,
                labelClassName: item.key === 'totalDiscounts' && textBold_700,
              };
            });
            paymentDetail.push(objRes);
            break;
          // ------------------ //
          default:
            objRes.priceStyle = {
              ...JOYBUY_TEXT_1,
            };
            paymentDetail.push(objRes);
            break;
        }
      });

      // Assignment
      self.paymentDetail = paymentDetail;
      console.log('______________________', paymentDetail);

      // 如果没有促销，itemsToal =  subToal
      trackObj.itemTotal = trackObj.itemTotal || trackObj.subTotal || '-100';
      trackObj.save = trackObj.save || '0.00';
      trackObj.totalDiscount = trackObj.totalDiscount || '0.00';
      self.paymentTrackInfo = trackObj;
    },
    // 订单应付金额
    setOrderPaymentPrice: (data: string) => {
      self.orderPaymentPrice = data;
    },
    // Set imageDomain
    setImageDomain(data: string) {
      self.imageDomain = data;
    },
    // Set sku items
    setOrderList(data: any[]) {
      self.orderList = [...data];

      self.currentDetailList = data[self.currentDetailIndex].nodeList;
      const skuArr: string[] = [];
      const orderType = data.length === 1 ? (data[0].nodeList.length === 1 ? '0' : '1') : '2';
      const tmpItems: any[] = [];
      /** 商品埋点数据 */
      self.trackOrderList = [...data].map((item: any, index: number) => {
        return {
          floorType: orderType,
          is_more: item.nodeList.length > 3 ? '1' : '0',
          items: item.nodeList.map((v: any) => {
            const tmp = {
              skuid: v.skuId,
              pdCnt: Number(v.num),
              firprice: v.deliveryPrice || '-100',
              secprice: v.jdPrice || '-100',
              //参见文档：https://joyspace.jd.com/sheets/bvmEjIBjcEm0nhrktZ2p
              firpricetype: '11',
              secpricetype: '44',
              order_items: String(index + 1),
              fastDeliveryTime:
                (
                  (item.promise?.deliveryDateDesc || '') +
                  ' ' +
                  (item.promise?.deliveryDate || '')
                ).trim() || '-100',
            };
            skuArr.push(v.skuId);
            tmpItems.push({ ...tmp, is_shortstock: '-100' });
            return { ...tmp };
          }),
        };
      });
      self.trackOrderInfo = {
        floortType: orderType,
        items: [...tmpItems],
      };
      self.skuIds = skuArr; // 埋点数据
    },
    setCouponInfo(data: CouponInfoVo) {
      self.couponInfo = data;
      console.log(data, 'self.couponInfo');

      self.trackCouponInfo = {
        text: '-100',
        isCoupon: data?.availableNum > 0 ? '1' : '0',
        couponId: data?.couponId || '-100',
        batchId: data?.batchId || '-100',
        use_threshold: data?.quota || '-100',
        couponType: data?.couponType || '-100',
        couponSave: data?.discountAmount || '-100',
      };
    },
    setCommonError(data: any) {
      self.commonError = data;
    },
    setOrderErrorOpen(data: boolean) {
      self.orderErrorOpen = data;
    },
    setOrderErrorMsg(data: any) {
      self.orderErrorMsg = data;
    },
    setAddressId(id: number) {
      self.addressId = id;
    },
    setRepayOrderId(id: string) {
      self.repayOrderId = id;
    },
    setQueryCurrentOrder(data: any) {
      self.queryCurrentOrder = JSON.parse(JSON.stringify(data));
    },
    setSafetyLoading(data: boolean) {
      self.safetyLoading = data;
    },
    setCardModalOpen(data: boolean) {
      self.cardModalOpen = data;
    },
    setBillingAddress(data: UserAddressVo) {
      self.billingAddress = {
        ...data,
        addressId: Number(data.addressId),
      };
    },
    setIsBillingAddressEdit(data: boolean) {
      self.isBillingAddressEdit = data;
    },
    setZeroInfo(data: ZeroInfoVo) {
      self.zeroInfo = data;
    },
    // BNP支付 浏览器信息
    setBrowserInfo(data: any) {
      self.browserInfo = data;
    },
    setIsAllHappyHour(data: boolean) {
      self.isAllHappyHour = !!data;
    },
    // 前端禁用支付方式列表
    setDisabledPayMethods: (data: string[]) => {
      self.disabledPayMethods = data;
    },
    setCurrentEditBundleUuid: (data: string) => {
      self.currentEditBundleUuid = data;
    },
    setIsPromiseListShow: (data: boolean) => {
      self.isPromiseListShow = data;
    },
    setIsClient: (data: boolean) => {
      self.isClient = data;
    },
    setPickUser(data: any) {
      self.pickUser = data;
    },
  }));

export type CheckoutStoreModel = Instance<typeof CheckoutStoreModel>;
